<template>
  <PopUp
    :show="showPopup"
    @update:show="showPopup = $event"
    position="right"
    popupBackgroundColor="#a7f3ad"
    :duration="4000"
  >
    <h2>{{ first_name }} {{ last_name }},</h2>
    <p>Votre compte a bien été créé !</p>
    <p>Vous allez être redirigé vers la page de connexion.</p>
  </PopUp>

  <div class="register-container">
    <h2 class="form-title">S'inscrire</h2>

    <form @submit.prevent="handleRegister" class="register-form">
      <div class="form-group">
        <label>Email BGE :</label>
        <input v-model="email" type="email" required />
      </div>

      <div class="form-group">
        <label>Prénom :</label>
        <input v-model="first_name" type="text" required />
      </div>

      <div class="form-group">
        <label>Nom :</label>
        <input v-model="last_name" type="text" required />
      </div>

      <div class="form-group">
        <label>Mot de passe :</label>
        <div class="password-container">
          <input v-model="password" :type="showPassword ? 'text' : 'password'" required />
          <i class="material-icons toggle-password" @click.prevent="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</i>
        </div>
      </div>

      <div class="form-group">
        <label>Confirmation du mot de passe :</label>
        <div class="password-container">
          <input v-model="verif_password" :type="showPassword ? 'text' : 'password'" required />
          <i class="material-icons toggle-password" @click.prevent="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</i>

        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="primary-button">S'inscrire</button>
      </div>
    </form>

    <p v-if="TextError" class="error">{{ TextError }}</p>
  </div>
</template>

<script setup>
import PopUp from '@/components/PopUp.vue';
import { ref } from 'vue';
import api from '@/api.js';
import { useRouter } from 'vue-router';

const showPopup      = ref(false);
const email          = ref('');
const first_name     = ref('');
const last_name      = ref('');
const password       = ref('');
const verif_password = ref('');
const showPassword   = ref(false)

const TextError = ref('');

const router = useRouter();

const handleRegister = async () => {
  TextError.value = '';

  if (password.value !== verif_password.value) {
    TextError.value = 'Le mot de passe et sa confirmation doivent être identiques.';
    return;
  }

  const formData = {
    email: email.value,
    first_name: first_name.value,
    last_name: last_name.value,
    password: password.value,
  };

  try {
    const response = await api.post('/register/', formData);
    console.log(response.data.message);
    showPopup.value = true;
    setTimeout(() => {
      router.push('/Login');
    }, 4000);
  } catch (error) {
    console.error(error.response?.data || error.message);

    if (error.response?.data?.type_error === 1) {
      TextError.value = 'Un compte existe déjà avec cette adresse e-mail.';
    } else if (error.response?.data.code === "INVALID_EMAIL_DOMAIN") {
      TextError.value = error.response.data.error
    } else {
      TextError.value = "Une erreur est survenue lors de la création du compte. Veuillez réessayer.";
    }
  }
};
</script>

<style scoped lang="scss">
.register-container {
  max-width: 400px;
  margin: 3rem auto;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.form-title {
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  font-weight: bold;
  color: #333;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 0.3rem;
  color: #555;
}

.form-group input {
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.primary-button {
  background-color: #3b82f6;
  color: white;
  padding: 0.7rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.primary-button:hover {
  background-color: #2563eb;
}

.error {
  color: #d71637;
  margin-top: 1rem;
  text-align: center;
  font-weight: 500;
}

.password-container {
  position: relative;
}

.password-container input {
  width: 100%;
  padding-right: 40px;
  box-sizing: border-box;
}

.password-container .toggle-password {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    color: $orange
  }
}
</style>
